export const PLAN_ANNUAL = 'annual'
export const PLAN_MONTHLY = 'monthly'

export const PLAN_FREE = 'plan_free'
export const PLAN_PRO = 'plan_pro'
export const PLAN_PRO2 = 'plan_pro2'
export const PLAN_PRO3 = 'plan_pro3'
export const PLAN_TEAM = 'plan_team'
export const PLAN_TEAMPERSEAT = 'plan_teamperseat'
export const PLAN_TEAM3SEATS = 'plan_team3seats'
export const PLAN_TEAMPERSEAT2 = 'plan_teamperseat2'
export const PLAN_AGENCY = 'plan_agency'

export const PRO_PLANS = [PLAN_PRO, PLAN_PRO2, PLAN_PRO3]

export const TEAM_PLANS = [
  PLAN_TEAM,
  PLAN_TEAMPERSEAT,
  PLAN_TEAM3SEATS,
  PLAN_TEAMPERSEAT2,
]

const ADVANCED_PLANS = [...PRO_PLANS, ...TEAM_PLANS, PLAN_AGENCY]

export const isProPlan = (plan: string | null) =>
  plan && PRO_PLANS.includes(plan)

export const isTeamPlan = (plan: string | null) =>
  plan && TEAM_PLANS.includes(plan)

export const isTeamOrAgencyPlan = (plan: string | null) =>
  plan && [...TEAM_PLANS, PLAN_AGENCY].includes(plan)

export const isAdvancedPlan = (plan: string) => ADVANCED_PLANS.includes(plan)

// Anything that is not Free: the gate for features every paid plan gets, such
// as saving a project as a template.
export const isPaidPlan = (plan: string | null | undefined) =>
  Boolean(plan) && plan !== PLAN_FREE
